"use client"

import { OTPInput as OTPInputComponent, SlotProps } from "input-otp"

import { cn } from "@/lib/utils"

interface OTPInputProps {
  id: string
  containerClassName: string
  maxLength: number
  masked?: boolean
  value?: string
  onChange?: (value: string) => void
}

export default function OTPInput({
  id,
  containerClassName,
  maxLength,
  masked,
  value,
  onChange,
}: OTPInputProps) {
  return (
    <OTPInputComponent
      id={id}
      containerClassName={containerClassName}
      maxLength={maxLength}
      value={value}
      autoComplete="one-time-code"
      pattern="[0-9]"
      onChange={onChange}
      render={({ slots }) => (
        <div className="flex gap-2" data-testid="otp-slots-container">
          {slots.map((slot, idx) => (
            <Slot key={idx} masked={!!masked} {...slot} index={idx} />
          ))}
        </div>
      )}
    />
  )
}

function Slot(props: SlotProps & { masked: boolean; index: number }) {
  return (
    <div
      role="presentation"
      data-testid={`otp-slot-${props.index}`}
      data-masked={props.masked}
      className={cn(
        "border-input bg-background text-foreground flex size-14 items-center justify-center rounded-xl border font-medium shadow-xs transition-[color,box-shadow]",
        { "border-ring ring-ring/50 z-10 ring-[3px]": props.isActive }
      )}
    >
      <div>{props.char !== null && (props.masked ? "\u2022" : props.char)}</div>
    </div>
  )
}
